import Vue from 'vue'
import JsEncrypt from 'jsencrypt'
import Jencryptlong from 'encryptlong'

let publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCnLg0lZJq4suk8/0Iuim4g3nNF0/QjIu4CtyFg4xGGsv5gOgmagZLixNu3SfhzZfp6QdzHO3a76G3PCXJnjzBYWy7DqR0zDNpWnCWOTqNtCx+Apt7OrsikrcZweK8UD+hKYr0Zub0H/H+aRc8EbtJaHZda71xzKBQeITmREIM2bQIDAQAB';

//RSA加密
export const  $encruptionData = function (obj) {
      return $encruption(publicKey,obj);
}

//RSA加密
export const  $encruption = function (key,obj) {
      console.log(obj)
      /*
        let encrypt = new JsEncrypt();
        encrypt.setPublicKey(key);
        var data = encrypt.encrypt(obj);
        console.log("------encruption："+data);
       */
        let en=new Jencryptlong();
        en.setPublicKey(key);
        var data = en.encryptLong(obj);
        console.log("------encruption："+data);
        return data;
}
//RSA解密
export const $decryption = function (key,obj) {
    let _decryp = new JsEncrypt();
    _decryp.setPrivateKey(key)
    // console.log(obj)
    var data = _decryp.decrypt(obj)
    // console.log(data)
    return data
}


// WEBPACK FOOTER //
// ./src/utils/jssHttp.js